import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React, { useEffect, useRef, useState } from "react"
import { View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
function PdfViewer({ file, width, height }) {
    const [isLoading, setIsLoading] = useState(true)
    const [hasError, setHasError] = useState(false)

    const iframeRef = useRef(null)

    useEffect(() => {
        let timeoutId
        if (isLoading) {
            timeoutId = setTimeout(() => {
                setIsLoading(false)
                setHasError(true)
            }, 5000)
        }
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId)
            }
        }
    }, [isLoading])

    const handleLoad = () => {
        try {
            const iframeUrl = iframeRef.current?.contentWindow?.location?.href

            if (
                iframeUrl &&
                (iframeUrl === "about:blank" ||
                    iframeUrl.startsWith("about:blank#blocked"))
            ) {
                setHasError(true)
            }
        } catch (e) {
            console.error("Error checking iframe URL:", e)
        }
        setIsLoading(false)
    }

    return (
        <>
            {hasError ? (
                <View
                    style={{
                        height: "90%",
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: theme.colors.whiteAlmost,
                        padding: 20,
                    }}
                >
                    <FontAwesome5
                        name="exclamation-triangle"
                        size={50}
                        color={theme.colors.warning}
                        style={{ marginBottom: 15 }}
                    />
                    <TextM
                        color={theme.colors.grey}
                        fontWeight="SemiBold"
                        fontSize={16}
                        style={{ textAlign: "center" }}
                    >
                        Il n'y a pas d'aperçu disponible
                    </TextM>
                </View>
            ) : (
                <>
                    {isLoading && (
                        <View
                            style={{
                                height: height ?? "90%",
                                width: width ?? "100%",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: theme.colors.whiteAlmost,
                            }}
                        >
                            <ActivityIndicator
                                size="large"
                                color={theme.colors.primary}
                            />
                        </View>
                    )}
                    <iframe
                        ref={iframeRef}
                        src={file}
                        height={height ?? "90%"}
                        width={width ?? "100%"}
                        style={{ alignSelf: "center" }}
                        onLoad={handleLoad}
                        onError={() => {
                            setIsLoading(false)
                            setHasError(true)
                        }}
                        hidden={isLoading}
                    />
                </>
            )}
        </>
    )
}
export default PdfViewer
